export function cartItemKey(productId, weight, grind) {
    return `${productId}|${weight}|${grind}`;
}
export function cartReducer(state, action) {
    switch (action.type) {
        case 'add': {
            const key = cartItemKey(action.item.productId, action.item.weight, action.item.grind);
            const existing = state.find((line) => line.key === key);
            if (!existing)
                return [...state, { ...action.item, key }];
            return state.map((line) => line.key === key ? { ...line, qty: line.qty + action.item.qty } : line);
        }
        case 'setQty': {
            if (action.qty <= 0)
                return state.filter((line) => line.key !== action.key);
            return state.map((line) => (line.key === action.key ? { ...line, qty: action.qty } : line));
        }
        case 'remove':
            return state.filter((line) => line.key !== action.key);
        case 'clear':
            return [];
    }
}
export const cartCount = (items) => items.reduce((sum, line) => sum + line.qty, 0);
export const cartTotal = (items) => items.reduce((sum, line) => sum + line.unitPrice * line.qty, 0);
